import { accountMap as accountMapV1 } from '../configs/tools/setup/account-map';
import { ccAlwaysDisplayedItem } from '../configs';

export const accountMap = {
  ...ccAlwaysDisplayedItem,
  ...accountMapV1,
  description: _TL_('View a full visual picture of your account structure.'),
  route: 'AccountMap',
};
